import { createStore } from '@/src/hooks/store/createStore';

interface EventRulesState {
  accepted: Record<string, boolean>;
  setAccepted: (eventName: string, accepted: boolean) => void;
}

export const useEventRules = createStore<EventRulesState>('event-rules', (set, get) => ({
  accepted: {},
  setAccepted: (eventName, accepted) =>
    set({
      accepted: {
        ...get().accepted,
        [eventName]: accepted,
      },
    }),
}));
